import { ErrorMessage, Field } from "formik";
import AsteriskLabel from "../../Common/AsteriskLabel";

export default function NumberInputBox({ title, name, placeholder, key, showstar=true  }) {
  const handleKeyDown = (e) => {
    const input = e.target.value;
    
    // Allow control keys
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab" ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    // Allow numbers
    if (/[0-9]/.test(e.key)) {
      // Check if we're adding a digit after decimal point
      if (input.includes('.')) {
        const decimalPart = input.split('.')[1];
        if (decimalPart && decimalPart.length >= 2) {
          e.preventDefault();
          return;
        }
      } else {
        // Check total digits before decimal (including the new one)
        const integerPart = input.split('.')[0];
        if (integerPart && integerPart.replace(/[^0-9]/g, '').length >= 12) {
          e.preventDefault();
          return;
        }
      }
      return;
    }

    // Allow decimal point only if not already present and there are digits before it
    if (e.key === '.' && !input.includes('.') && input.length > 0 && /[0-9]/.test(input[input.length - 1])) {
      return;
    }

    // Prevent all other keys
    e.preventDefault();
  };

  const handleChange = (e, form) => {
    const value = e.target.value;
    
    // Allow empty value
    if (value === '') {
      form.setFieldValue(name, '');
      return;
    }

    // Validate the format: maximum 12 digits before decimal, maximum 2 after decimal
    const regex = /^\d{1,12}(\.\d{0,2})?$/;
    
    if (regex.test(value)) {
      form.setFieldValue(name, value);
    }
  };

  return (
    <div key={key} className="form-group">
      <label>{title} {showstar && title ? <AsteriskLabel /> : ""}</label>
      <Field name={name}>
        {({ field, form }) => (
          <input
            {...field}
            type="text" // Use text type to avoid browser number input quirks
            placeholder={placeholder}
            className="form-control"
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(e, form)}
            value={field.value || ''}
          />
        )}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="error"
        style={{ color: "red" }}
      />
    </div>
  );
}